'use client';

import { useEffect, useSyncExternalStore } from 'react';

/**
 * 서비스 팝업을 잠깐 붙드는 자리 — 화면이 «지금은 방해하지 말라»고 걸어 둔다(예: 대화 화면의 답이 서는 중).
 * 🔑 붙든 화면이 하나라도 있으면 팝업은 고르지 않고 기다린다 — 풀리면 그때 고른다.
 * 🔑 다른 창이 떠 있어도 기다린다(`isOtherModalOpen`) — 닫히면 그때 고른다.
 */

/**
 * 이 화면이 팝업을 붙든다 — `on` 이 참인 동안, 그리고 화면이 서 있는 동안만.
 * @param on 지금 붙들어야 하나
 */
export function useServicePopupHold(on: boolean): void {
  useEffect(() => {
    if (!on) return undefined;
    const token = {};
    holds.add(token);
    emit();
    return () => {
      holds.delete(token);
      emit();
    };
  }, [on]);
}

/** 다른 창(대화상자 · 서랍 · 메뉴 · 팝오버 — MUI 모달)이 떠 있나 — 사람이 그 일을 하는 중이다 */
export function isOtherModalOpen(): boolean {
  if (typeof document === 'undefined') return false;
  return document.querySelector('.MuiModal-root:not(.MuiModal-hidden)') !== null;
}

/** 지금 붙든 화면이 있나 — 서비스 팝업이 읽는다 */
export function useServicePopupHeld(): boolean {
  return useSyncExternalStore(subscribe, isHeld, isNotHeld);
}

// ---- 이하 비공개 ----------------------------------------------------------

const holds = new Set<object>();
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit(): void {
  listeners.forEach((listener) => listener());
}

function isHeld(): boolean {
  return holds.size > 0;
}

function isNotHeld(): boolean {
  return false;
}
